import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Linha de busca + filtros que quebra de forma limpa. `flex-wrap` mantém os
 * controles na mesma linha enquanto cabem e, quando não cabem, empilham em vez
 * de estourar. Combine com `SearchInput` (largura total no mobile) e Selects
 * usando `w-full sm:w-[Npx]` para que fiquem inline no desktop e cheios quando
 * empilhados. `items-center` por padrão; passe `items-end` quando houver labels.
 */
export function FilterToolbar({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn("flex flex-wrap items-center gap-2", className)} {...props}>
      {children}
    </div>
  );
}

export default FilterToolbar;
